import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, share } from 'rxjs/operators';
import { ConfigService } from 'src/app/shared/config';
import { environment } from "src/environments/environment"
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { NotificationService } from 'src/app/shared/notification.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';

@Injectable({
  providedIn: 'root'
})
export class ReguleringService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private afs: AngularFirestore, private config: ConfigService, private notifierService: NotificationService, private http: HttpClient) {

  }

  requestRegulering(data) {
    console.log(data, this.config.getCompanyId())
    data.companyId = this.config.getCompanyId();
    this.http.post(environment.apiUrl + "/widgets/porudctRegulering", JSON.stringify(data), this.httpOptions).subscribe((sp) => {
      console.log(sp)

    }, error => {
      console.log(error.error)
      this.notifierService.showNotification('error', error.error.message);

    })

  }

  applyChangesForAll(data) {
    console.log(this.config.getCompanyId())
    data['companyId'] = this.config.getCompanyId();
    
    console.log(data)

    // data = JSON.parse(data)
    this.http.post(environment.apiUrl + "/widgets/applychangesforall", JSON.stringify(data), this.httpOptions).subscribe((sp) => {
      console.log(sp)
      this.notifierService.showNotification('error', sp['message']);

    }, error => {
      console.log(error.error)
      this.notifierService.showNotification('error', error.error.message);

    })

  }

  getRegulerings() {

    return this.afs.collection('productRegulering', ref => ref.where('companyId', '==', this.config.getCompanyId()).limit(20).orderBy('timestamp', 'desc')).snapshotChanges().pipe(
      map(snapshotChange => snapshotChange.map(
        snapshot => {
          return {
            ...snapshot.payload.doc.data() as Object,
            dbid: snapshot.payload.doc.id,
            timestamp: moment.unix(snapshot.payload.doc.data()['timestamp']).tz('Europe/Oslo').format('DD-MM-YYYY HH:mm')

            ,performAt: moment.unix(snapshot.payload.doc.data()['performAt']).tz('Europe/Oslo').format('DD-MM-YYYY HH:mm')
          }
        }
      ))
    );
  }


  getApplyChanges() {

    return this.afs.collection('applyChangesforAll', ref => ref.where('companyId', '==', this.config.getCompanyId()).limit(5).orderBy('timestamp', 'desc')).snapshotChanges().pipe(
      map(snapshotChange => snapshotChange.map(
        snapshot => {
          return {
            ...snapshot.payload.doc.data() as Object,
            dbid: snapshot.payload.doc.id,
            timestamp: moment.unix(snapshot.payload.doc.data()['timestamp']).tz('Europe/Oslo').format('DD-MM-YYYY HH:mm')
            ,performAt: moment.unix(snapshot.payload.doc.data()['performAt']).tz('Europe/Oslo').format('DD-MM-YYYY HH:mm')

          }
        }
      ))
    );
  }


  getReguleringsRefrences(data) {

    return this.afs.collection('productRegulering').doc(data.dbid).collection('productReguleringRefrences').snapshotChanges().pipe(
      map(snapshotChange => snapshotChange.map(
        snapshot => {
          return {
            ...snapshot.payload.doc.data() as Object,
            dbid: snapshot.payload.doc.id,
            timestamp: moment.unix(snapshot.payload.doc.data()['timestamp']).tz('Europe/Oslo').format('DD-MM-YYYY HH:mm')

          }
        }
      ))
    );
  }

  getApplyChangesRefrences(data) {

    return this.afs.collection('applyChangesforAll').doc(data.dbid).collection('refrencesToApplyChangesPerSystem').snapshotChanges().pipe(
      map(snapshotChange => snapshotChange.map(
        snapshot => {
          return {
            ...snapshot.payload.doc.data() as Object,
            dbid: snapshot.payload.doc.id,
            timestamp: moment.unix(snapshot.payload.doc.data()['timestamp']).tz('Europe/Oslo').format('DD-MM-YYYY HH:mm'),
            systemName : snapshot.payload.doc.data()['systemName'] ? snapshot.payload.doc.data()['systemName'] : snapshot.payload.doc.data()['siteName']


          }
        }
      ))
    );
  }

}
